/** Page math shared by roster screens; pages are zero-based in application state. */
export function rosterPagination({ total, limit, offset, }) {
    if (!Number.isInteger(total) || total < 0) {
        throw new RangeError('total must be a non-negative integer');
    }
    if (!Number.isInteger(limit) || limit < 1) {
        throw new RangeError('limit must be a positive integer');
    }
    if (!Number.isInteger(offset) || offset < 0) {
        throw new RangeError('offset must be a non-negative integer');
    }
    const pageCount = Math.max(1, Math.ceil(total / limit));
    const page = Math.min(Math.floor(offset / limit), pageCount - 1);
    const normalizedOffset = page * limit;
    return {
        page,
        pageCount,
        from: total === 0 ? 0 : normalizedOffset + 1,
        to: Math.min(normalizedOffset + limit, total),
        previousDisabled: page === 0,
        nextDisabled: page >= pageCount - 1,
        previousOffset: Math.max(0, normalizedOffset - limit),
        nextOffset: Math.min((pageCount - 1) * limit, normalizedOffset + limit),
    };
}
//# sourceMappingURL=pagination.js.map